// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"194": "__federation_expose_app","827": "__federation_expose_constants",}[chunkId] || chunkId) + "." + {"109": "d4c2fe83b4191e38","194": "4363c63ef5621027","265": "43e2bce7908d0d16","573": "04779141132dd418","668": "54e09c4885c0c52a","736": "ae69bf00efac3e58","772": "40c40cde4db6edb9","827": "cc0cf3377aa0d627","964": "5c657a734d30edd5",}[chunkId] + ".js"
}